export enum SharedErrors {
  CANCELLED_BY_USER = 'cancelled-by-user',
}
